import { render, staticRenderFns } from "./ActHandleBtn.vue?vue&type=template&id=ad0a407a"
import script from "./ActHandleBtn.vue?vue&type=script&lang=js"
export * from "./ActHandleBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports